import { LiveChatStatus } from '../constants/live-chat-status'

export type LiveChatAvailabilityResp = {
  status: LiveChatStatus
  reason: string
  availability_information: string
}

export type CreateLiveChatTicketArgs = {
  ch: string
  transactionId: number
  englishAllowed: boolean
  message: string
  helpCenterSessionId?: string | null
}

export const createLiveChatTicketArgsToParams = ({
  transactionId,
  ch,
  englishAllowed,
  message,
  helpCenterSessionId,
}: CreateLiveChatTicketArgs) => ({
  ch,
  transaction_id: transactionId,
  english_allowed: englishAllowed,
  message,
  help_center_session_id: helpCenterSessionId,
})
